import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
// import Toggle from 'react-toggle';
import moment from 'moment';
import { APP_DATE_FORMAT, VALID_URL_REGEX } from '../../../config/app_config';
import {
  renderDisabledStatus,
  renderEnabledStatus,
  storeWithExpiration,
} from '../../../utils/common';
import {
  cancelUpdate,
  getEloquaConfig,
  getMarketoConfig,
  updateEloquaConfig,
  updateMarketoConfig,
} from '../../../actions/customerPortal';
import ConfigureMarketoInstallForm from './ConfigureMarketoInstallForm';
import ConfigureEloquaInstallForm from './ConfigureEloquaInstallForm';

const FORM_ID = 'configureInstallForm';
// const PLATFORM = 'MARKETO';

const PLATFORM_MARKETO = 'MARKETO';
const PLATFORM_ELOQUA = 'ELOQUA';

export class ConfigureInstall extends React.Component {
  static propTypes = {
    authUrl: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    invalid: PropTypes.bool.isRequired,
    getMarketoConfigAction: PropTypes.func.isRequired,
    getEloquaConfigAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateMarketoConfigAction: PropTypes.func.isRequired,
    updateEloquaConfigAction: PropTypes.func.isRequired,
    whiteLabelCompany: PropTypes.string.isRequired,
  };

  state = {
    nightlyBulkMatching: true,
    prospecting: true,
  };

  componentWillMount = () => {
    const { getMarketoConfigAction, getEloquaConfigAction, data } = this.props;
    const token = storeWithExpiration.get('token');
    const { installation, platformCode } = data;
    const installId = installation.get('id');
    if (platformCode === PLATFORM_MARKETO) getMarketoConfigAction(installId, token);
    else if (platformCode === PLATFORM_ELOQUA) getEloquaConfigAction(installId, token);
  };

  handleBulkMatchingChange = () => {
    // Toggle state
    this.setState({ nightlyBulkMatching: !this.state.nightlyBulkMatching });
  };

  handleProspectingChange = () => {
    // Toggle state
    this.setState({ prospecting: !this.state.prospecting });
  };

  performConfigUpdate = params => {
    const { updateMarketoConfigAction, data } = this.props;
    const { installation } = data;
    const installId = installation.get('id');
    const token = storeWithExpiration.get('token');

    const configObj = {
      description: params.description.trim(),
      auth: {
        clientId: params.clientId.trim(),
        clientSecret: params.clientSecret.trim(),
        restUrl: params.restUrl.trim(),
        identityUrl: params.identityUrl.trim(),
      },
    };

    updateMarketoConfigAction(configObj, installId, token);
  };

  performEloquaConfigUpdate = params => {
    const { authUrl, updateEloquaConfigAction, data } = this.props;
    const { installation } = data;
    const installId = installation.get('id');
    const token = storeWithExpiration.get('token');

    const configObj = {
      description: params.description.trim(),
      auth: {
        authUrl,
      },
    };

    updateEloquaConfigAction(configObj, installId, token);
  };

  render() {
    const { authUrl, invalid, handleSubmit, submitting, data, whiteLabelCompany } = this.props;
    const { installation, platformCode } = data;
    const isMarketo = platformCode === PLATFORM_MARKETO;
    const status = installation.get('installStatus');
    const name = installation.get('description');
    const lastUpdateDate = moment(installation.get('updatedOn')).format(APP_DATE_FORMAT);

    return (
      <div className="modal-wrap">
        <div className="row row-top">
          <div className="col-xs-12">
            <h1>Configure Your {whiteLabelCompany} Instance</h1>
          </div>
        </div>
        <div className="container container-home info-section">
          <div className="row">
            <div className="col-sm-12">
              <span className="pull-right">
                Status:{' '}
                <i>{status === 'INSTALLED' ? renderEnabledStatus() : renderDisabledStatus()}</i>
              </span>
              <h4>{name}</h4>
              <p>
                Last updated <i>{lastUpdateDate}</i>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-8 col-lg-6">
              {isMarketo ? (
                <ConfigureMarketoInstallForm
                  handleSubmit={handleSubmit}
                  invalid={invalid}
                  submitting={submitting}
                  updateConfigFunction={this.performConfigUpdate}
                />
              ) : (
                <ConfigureEloquaInstallForm
                  authUrl={authUrl}
                  handleSubmit={handleSubmit}
                  invalid={invalid}
                  submitting={submitting}
                  updateConfigFunction={this.performEloquaConfigUpdate}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.description || values.description.trim() === '') {
    errors.description = 'Required';
  }
  if (!values.clientId || values.clientId.trim() === '') {
    errors.clientId = 'Required';
  }
  if (!values.clientSecret || values.clientSecret.trim() === '') {
    errors.clientSecret = 'Required';
  }
  if (!values.restUrl || values.restUrl.trim() === '') {
    errors.restUrl = 'Required';
  } else if (!values.restUrl.match(VALID_URL_REGEX)) {
    errors.restUrl = 'Invalid URL';
  }
  if (!values.identityUrl || values.identityUrl.trim() === '') {
    errors.identityUrl = 'Required';
  } else if (!values.identityUrl.match(VALID_URL_REGEX)) {
    errors.identityUrl = 'Invalid URL';
  }

  return errors;
};

const ConfigureInstallRF = reduxForm({
  form: FORM_ID,
  validate,
  enableReinitialize: true,
})(ConfigureInstall);

function mapStateToProps(state) {
  const { account, customerPortalData } = state;
  let initialValues = {};
  let authUrl = '';
  const currentPlatformType = customerPortalData.get('currentPlatformType');
  const marketoAuthConfig = customerPortalData.get('marketoAuthConfig');
  const eloquaAuthConfig = customerPortalData.get('eloquaAuthConfig');

  switch (currentPlatformType) {
    case PLATFORM_MARKETO: {
      const { description } = marketoAuthConfig;
      initialValues = { description };
      if (marketoAuthConfig.auth) {
        const { clientId } = marketoAuthConfig.auth;
        const { clientSecret } = marketoAuthConfig.auth;
        const { restUrl } = marketoAuthConfig.auth;
        const { identityUrl } = marketoAuthConfig.auth;
        initialValues = {
          description,
          clientId,
          clientSecret,
          restUrl,
          identityUrl,
        };
      }
      break;
    }
    case PLATFORM_ELOQUA: {
      const { description } = eloquaAuthConfig;
      initialValues = { description };
      if (eloquaAuthConfig.auth) {
        // eslint-disable-next-line
        authUrl = eloquaAuthConfig.auth.authUrl;
        initialValues = {
          description,
          authUrl,
        };
      }
      break;
    }
    default:
      break;
  }

  return { account, initialValues, authUrl };
}

export default connect(mapStateToProps, {
  cancelSettingsUpdateAction: cancelUpdate,
  getEloquaConfigAction: getEloquaConfig,
  getMarketoConfigAction: getMarketoConfig,
  updateEloquaConfigAction: updateEloquaConfig,
  updateMarketoConfigAction: updateMarketoConfig,
})(ConfigureInstallRF);
